import fetchApi from '../fetch-api'
import CompanyIO from '../company-io'

type CompanyByIdPropsT = {
  companyID: string|undefined
}

export const getAdminCompanyById = (props: CompanyByIdPropsT) => {
  const { companyID } = props
  return {
    queryKey: ['COMPANY_DETAIL', companyID],
    queryFn: () =>
      fetchApi({
        service: 'admin-service',
        headers:{method: 'GET'},
        pathname: `/company-detail?companyID=${companyID}`,
        codec: CompanyIO,
      }),
  }
}
